export default {
     options: {},

    /**
     * 初始化
     */
    configMatomo(options){
        this.options = options;

        // 是否开启监听
        if(!this.options.open){
            return false;
        }
        const trackerEndpoint = options.trackerUrl || `${options.host}/${options.trackerFileName}.php`;
        window._paq = window._paq || [];

        // 0. 必须的值
        if(trackerEndpoint){
            this.sendBaseMethod('setTrackerUrl',trackerEndpoint);
        }else {
            if(this.options.debug){
                console.log('matomo sendBaseMethod api trackerEndpoint not empty')
            }
        }


        if(options.siteId){
            this.sendBaseMethod('setSiteId',options.siteId);
        }else {
            if(this.options.debug){
                console.log('matomo sendBaseMethod api siteId not empty')
            }
        }

        // 1. 内部的页面监听
        this.sendBaseMethod('trackPageView');

        // 2. 监听连接
        if (options.enableLinkTracking) {
            this.sendBaseMethod('enableLinkTracking');
        }

        // 3. 心跳
        if (options.enableHeartBeatTimer) {
            this.sendBaseMethod('enableHeartBeatTimer',options.heartBeatTimerInterval);
        }

        // 4. 多级域名
        if (options.domains) {
            this.sendBaseMethod('setDomains',options.domains);
        }



    },

    /**
     * 执行matomo方法
     */
    sendBaseMethod(name, value){
        // 是否开启监听
        if(!this.options.open){
            return false;
        }
        if(!value){
            window._paq.push([name]);
        }else {
            window._paq.push([name, value]);
        }
    },
    /**
     *  发送埋点事件
     * @param category  事件分类
     * @param action  事件行为
     * @param name  事件名称
     * @param value  事件值
     */
    sendEndPointEvent(category, action, name, value){
        // 是否开启监听
        if(!this.options.open){
            return false;
        }
        if(!category || !action){
            if(this.options.debug){
                console.log('matomo sendEndPointEvent api param not empty',
                    'category = ',category,
                    'action = ',action ,
                    'name=', name);
            }

            return false;
        }

        if(!value){
            window._paq.push(['trackEvent', category, action, name]);
        }else {
            window._paq.push(['trackEvent', category, action, name, value]);
        }
    },
    /**
     * 发送用户事件
     */
    sendUserId(userId){
        // 是否开启监听
        if(!this.options.open){
            return false;
        }
        if(!userId || userId.length == 0){
          if(this.options.debug){
              console.log('埋点发送userId 不能为空');
          }
            return false;
        }
        if (this.options.supportUserId) {
            this.sendBaseMethod('setUserId',userId);
        }
    },
    /**
     * 发送自定义变量
     * @param index  一个从1到5的整数
     * @param name  自定义变量名称
     * @param value   自定义变量值
     * @param scope  option visit   page
     */
    sendCustomVariable(index, name, value, scope = "page"){
        // 是否开启监听
        if(!this.options.open){
            return false;
        }
        if(!name || !value){
           if(this.options.debug){
               console.log('matomo sendCustomVariable  param not empty',
                   'name = ',name,
                   'value = ',value);
           }
            return false;
        }
        window._paq.push(['setCustomVariable', index, name, value, scope]);
        window._paq.push(['trackPageView']);
    }
}
